import React, { useContext, useCallback, useEffect, useState } from "react";
import {
  Input,
  Button,
  Form,
  Row,
  Col,
  Select,
  message,
  DatePicker,
} from "antd";
import { FiltersContext, AuthContext } from "@CONTEXTS";
import { HJAddressSelectBox } from "@FORMS";
import { useLocation } from "react-router-dom";
import { moment } from "@LIBS";
import "moment/locale/tr";

moment.locale("tr");

const MIN_DATE = moment("2026-01-01");
const MAX_RANGE_DAYS = 90;
const DEFAULT_START_DATE = moment.max(
  moment().subtract(MAX_RANGE_DAYS, "days"),
  MIN_DATE.clone()
);
const DEFAULT_END_DATE = moment();

const Filters = () => {
  const { dispatch } = useContext(FiltersContext);
  const { info } = useContext(AuthContext);
  const [form] = Form.useForm();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const [initialStatus, setInitialStatus] = useState(query.get("status"));
  const [status, setStatus] = useState(
    info?.limitedWarehouses ? null : initialStatus || "notDeliveredOnly"
  );
  const [filterArea, setFilterArea] = useState(null);
  const [channel, setChannel] = useState(
    info?.onlyJetpartnerDeliveries
      ? "JETPARTNER"
      : sessionStorage.getItem("channel") === null
      ? "JETPARTNER"
      : sessionStorage.getItem("channel") === "null"
      ? null
      : sessionStorage.getItem("channel") === "INTEGRATION"
      ? "INTEGRATION"
      : sessionStorage.getItem("channel")
  );
  const [channelList, _setChannelList] = useState(
    info?.onlyJetpartnerDeliveries
      ? [{ value: "JETPARTNER", label: "JETPARTNER" }]
      : [
          { value: null, label: "Tüm Kanallar" },
          { value: "JETPARTNER", label: "JETPARTNER" },
          {
            value: "INTEGRATION",
            label: "DİĞER KANALLAR",
          },
        ]
  );
  const [warehouse, setWarehouse] = useState(null);
  const [defaultSelectedWarehouse, setDefaultSelectedWarehouse] =
    useState(null);
  const [selectedMerchant, _setSelectedMerchant] = useState(
    sessionStorage.getItem("merchantId") === "null" ||
      sessionStorage.getItem("merchantId") === null
      ? null
      : Number(sessionStorage.getItem("merchantId"))
  );
  const [filter, setFilter] = useState("");
  const isB2BPro = info?.specialTags?.includes("B2BPRO");
  // B2BPRO'da tarih alanlarıyla 7 filtre + buton, diğerlerinde 5 filtre + buton
  const colSpan = isB2BPro ? 6 : 4;
  const [startDate, setStartDate] = useState(
    isB2BPro ? DEFAULT_START_DATE : null
  );
  const [endDate, setEndDate] = useState(isB2BPro ? DEFAULT_END_DATE : null);
  const [openStartDate, setOpenStartDate] = useState(false);
  const [openEndDate, setOpenEndDate] = useState(false);

  useEffect(() => {
    setInitialStatus(query.get("status"));
  }, [location]);

  const setFilters = useCallback(
    (obj) => {
      dispatch({
        type: "SET_FILTERS",
        payload: obj,
      });
    },
    [dispatch]
  );

  const onFinish = (values) => {
    const { warehouse, merchant } = values;
    const obj = {};
    obj.notDeliveredOnly = false;
    const hasFilter = Array.isArray(filter)
      ? filter.length > 0
      : filter?.length > 0;
    if (hasFilter) {
      if (filterArea === "barcode") {
        obj.barcode = Array.isArray(filter) ? filter : [filter];
      } else if (filterArea === "receiverPersonGsm") {
        obj.receiverPersonGsm = filter;
      } else if (filterArea === "customerOrderId") {
        obj.customerOrderId = filter;
      } else {
        message.error({
          content: "Sorgulanacak alanı seçiniz!",
          className: "app-error-message",
        });
        return;
      }
    }
    if (
      status === "BT" ||
      status === "YT" ||
      status === "XL" ||
      status === "RETURNED" ||
      status === "STD"
    ) {
      obj.property = status;
    }
    if (status !== "notDeliveredOnly") {
      obj.status = status;
    }
    if (status === "notDeliveredOnly") {
      obj.notDeliveredOnly = true;
    }
    if (merchant) {
      obj.merchant = merchant;
    }
    if (channel) {
      obj.channel = channel;
    }
    if (warehouse) {
      obj.warehouseId = warehouse?.warehouseId;
    }
    if (warehouse && info?.limitedWarehouses) {
      obj.warehouseId = warehouse?.warehouseId;
    }
    if (!warehouse && defaultSelectedWarehouse) {
      obj.warehouseId = defaultSelectedWarehouse;
    }
    if (warehouse && defaultSelectedWarehouse) {
      obj.warehouseId = warehouse?.warehouseId;
    }
    if (isB2BPro && startDate && endDate) {
      obj.startDate = startDate.format("YYYY-MM-DD");
      obj.endDate = endDate.format("YYYY-MM-DD");
    }
    setFilters(obj);
  };

  useEffect(() => {
    const isEmptyFilter = Array.isArray(filter) ? filter.length === 0 : !filter;
    if (isEmptyFilter) {
      const defaultForm = form.getFieldValue();
      onFinish(defaultForm);
    }
  }, [
    filter,
    form,
    dispatch,
    status,
    selectedMerchant,
    warehouse,
    channel,
    defaultSelectedWarehouse,
    dispatch,
    initialStatus,
    selectedMerchant,
    warehouse,
    startDate,
    endDate,
  ]);

  return (
    <Row gutter={[24, 24]}>
      <Form
        // className="operation-filters"
        layout="inline"
        onFinish={(values) => onFinish(values)}
        form={form}
        style={{ width: "100%" }}
      >
        <Col span={colSpan}>
          <Form.Item label={null} name="filterArea" initialValue={filterArea}>
            <Select
              placeholder="Sorgulanacak alan"
              onChange={(e) => {
                setFilterArea(e);
                setFilter(null);
                form.setFieldsValue({ filter: undefined });
              }}
              value={filterArea}
              options={[
                { value: "barcode", label: "Barkod" },
                {
                  value: "receiverPersonGsm",
                  label: "Alıcı Telefonu",
                },
                {
                  value: "customerOrderId",
                  label: "Müşteri Sipariş No",
                },
              ]}
            />
          </Form.Item>
        </Col>
        <Col span={colSpan}>
          <Form.Item label={null} name="filter">
            {filterArea === "barcode" ? (
              <Select
                mode="tags"
                placeholder="Sorgulanacak değer"
                allowClear
                tokenSeparators={[",", " ", "\n"]}
                value={Array.isArray(filter) ? filter : []}
                onChange={(values) => {
                  if (values.length > 50) {
                    message.warning("En fazla 50 barkod girebilirsiniz");
                  }
                  setFilter(values.slice(0, 50));
                }}
                style={{ width: "100%" }}
                notFoundContent={null}
                maxTagCount={0}
                maxTagPlaceholder={() =>
                  `${
                    filter?.length > 50 ? 50 : filter?.length
                  } adet seçili barkod`
                }
              />
            ) : (
              <Input
                placeholder="Sorgulanacak değer"
                allowClear
                value={filter}
                onChange={(e) => {
                  setFilter(e.target.value);
                }}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={colSpan}>
          <Form.Item name="warehouse">
            <HJAddressSelectBox
              type="warehouse"
              placeholder="Çıkış Deposu"
              form={form}
              limitedWarehouses={info?.limitedWarehouses}
              notDefaultSelected={info?.limitedWarehouses ? false : true}
              setDefaultSelectedWarehouse={setDefaultSelectedWarehouse}
              onSelect={(i) => {
                setWarehouse(i);
              }}
            />
          </Form.Item>
        </Col>
        <Col span={colSpan}>
          <Form.Item label={null} name="status" initialValue={status}>
            <Select
              placeholder="Tüm Gönderiler"
              onChange={(e) => setStatus(e)}
              value={status}
              options={[
                { value: "all", label: "Tüm Gönderiler" },
                { value: "notDeliveredOnly", label: "Teslim edilmeyenler" },
                {
                  value: "received",
                  label: "Alınan Gönderiler",
                },
                {
                  value: "delivered",
                  label: "Teslim Edilenler",
                },
                {
                  value: "deliveryBranch",
                  label: "Teslimat Şubesinde",
                },
                {
                  value: "delivering",
                  label: "Kurye Dağıtıma Çıktı",
                },
                {
                  value: "transferring",
                  label: "Transfer Sürecinde",
                },
                {
                  value: "toBeTaken",
                  label: "Teslim Alınacaklar  ",
                },
                {
                  value: "returned",
                  label: "İade Edilenler",
                },
                {
                  value: "returning",
                  label: "İade Sürecinde",
                },
                {
                  value: "deliveryReturn",
                  label: "İade Alım Sürecinde",
                },
                { value: "STD", label: "Standart Teslimat" },
                { value: "YT", label: "Ertesi Gün Teslimat" },
                {
                  value: "XL",
                  label: "XL Gönderiler",
                },
              ]}
            />
          </Form.Item>
        </Col>
        <Col span={colSpan} style={{ marginTop: isB2BPro ? 24 : undefined }}>
          <Form.Item label={null} name="channel" initialValue={channel}>
            <Select
              placeholder="Kanallar"
              onChange={(e) => {
                sessionStorage.setItem("channel", e);
                setChannel(e);
              }}
              disabled={info?.onlyJetpartnerDeliveries}
              value={channel}
              options={channelList}
            />
          </Form.Item>
        </Col>
        {isB2BPro && (
          <>
            <Col span={colSpan} style={{ marginTop: 24 }}>
              <Form.Item>
                <DatePicker
                  placeholder="Başlangıç tarihi"
                  format="DD MMM YYYY"
                  allowClear
                  style={{ width: "100%" }}
                  open={openStartDate}
                  onOpenChange={setOpenStartDate}
                  value={startDate}
                  disabledDate={(current) => {
                    if (!current) return false;
                    return (
                      current.isBefore(MIN_DATE, "day") ||
                      (endDate &&
                        current.isBefore(
                          moment(endDate).add(-MAX_RANGE_DAYS, "days"),
                          "day"
                        )) ||
                      (endDate && current.isAfter(moment(endDate), "day"))
                    );
                  }}
                  onChange={(val) => {
                    setStartDate(val);
                    if (!endDate) {
                      setEndDate(val);
                      setOpenEndDate(true);
                    } else if (
                      val &&
                      endDate.diff(val, "days") > MAX_RANGE_DAYS
                    ) {
                      setEndDate(moment(val).add(MAX_RANGE_DAYS, "days"));
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={colSpan} style={{ marginTop: 24 }}>
              <Form.Item>
                <DatePicker
                  placeholder="Bitiş tarihi"
                  format="DD MMM YYYY"
                  allowClear
                  style={{ width: "100%" }}
                  open={openEndDate}
                  onOpenChange={setOpenEndDate}
                  value={endDate}
                  disabledDate={(current) => {
                    if (!current) return false;
                    return (
                      current.isBefore(MIN_DATE, "day") ||
                      (startDate &&
                        current.isBefore(moment(startDate), "day")) ||
                      (startDate &&
                        current.isAfter(
                          moment(startDate).add(MAX_RANGE_DAYS, "days"),
                          "day"
                        ))
                    );
                  }}
                  onChange={(val) => {
                    if (!startDate) {
                      setStartDate(val);
                      setOpenStartDate(true);
                    }
                    setEndDate(val);
                  }}
                />
              </Form.Item>
            </Col>
          </>
        )}
        <Col span={colSpan} style={{ marginTop: isB2BPro ? 24 : undefined }}>
          <Form.Item>
            <Button type="primary" block htmlType="submit">
              Ara
            </Button>
          </Form.Item>
        </Col>
      </Form>
    </Row>
  );
};

export default Filters;
